<template>
    <div id="app">
        <h3>Gestione Occupazione Campi</h3>
      <FieldAvailabilityTable 
        :fields="fields" 
        :selectedDate="selectedDate"
        :selectedDay="selectedDay"
        @day-change="handleDayChange"
      />
      <AccordionFields 
        :fields="fields" 
        :selectedDate="selectedDate"
        @date-change="handleDateChange"
      />
    </div>
  </template>
  
<script>
  import {ref, onMounted, getCurrentInstance,watch } from 'vue';
import Service from '@/services/levante-api/levante-api'
  import AccordionFields from './AccordionFields.vue';
  import FieldAvailabilityTable from '@/components/FieldAvailabilityTable.vue';
  
  export default {
    name: 'App',
    components: {
      AccordionFields,
      FieldAvailabilityTable,
    },
    setup() {
      const fields = ref([]);
      const selectedDate = ref(new Date());
      const selectedDay = ref(null); // null means show all days
      
      const fetchFields = async () => {
        try {
          const self = getCurrentInstance();
          self.$eventBus = self.appContext.config.globalProperties.$eventBus
          const service = new Service(self.$eventBus)
          const response = await service.getCorsoSessioniNextWeek();
          console.log(response);
          fields.value = response.items;
        } catch (error) {
          console.error(error);
        }
      };
      
      const handleDateChange = (newDate) => {
        selectedDate.value = newDate;
      };
      
      const handleDayChange = (day) => {
        selectedDay.value = day;
      };
      
      // Watch for selectedDate changes and refetch data
      watch(selectedDate, () => {
        fetchFields();
      });
      
      onMounted(() => {
        fetchFields();
      });
      
      return {
        fields,
        selectedDate,
        selectedDay,
        handleDateChange,
        handleDayChange
      };
    }
  };
  </script>